<template>
  <div>
    <div class="c-logo">
      <v-img
        v-if="whiteLabel && whiteLabel.logo"
        class="c-logo--white-label"
        :src="whiteLabel.logo"
        alt="logo" />
      <template v-else>
        <v-img v-if="!mini" class="c-logo__big" src="@/assets/images/logo.png" contain />
        <v-img v-else class="c-logo__mini" src="@/assets/images/logo-collapsed.png" contain />
      </template>
    </div>
    <div v-if="info && showInfo" class="logo-clinic-info">
      <span v-if="clinicEmail">
        <b> {{ $t("clinic.clinicEmail", { clinic: showClinicName }) }}</b>
        <a class="c-email" :href="`mailto:${clinicEmail}`">
          {{ clinicEmail }}
        </a>
      </span>
      <span v-if="clinicPhoneNumber && countryCode">
        <b> {{ localeAdaptedClinicPhoneLabel }}:</b>
        <a class="c-phone-number" :href="`tel:+${countryCode}${clinicPhoneNumber}`">
          <span class="c-country-code">{{ rtlAdaptedCountryCode }}</span> {{ clinicPhoneNumber }}
        </a>
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import externalServicesMixin from '@/common/mixins/externalServicesMixin';

export default {
  name: 'Logo',
  props: {
    mini: { type: Boolean, default: false },
    info: { type: Boolean, default: false },
  },
  mixins: [externalServicesMixin],
  data() {
    return {
      clinicEmail: null,
      clinicPhoneNumber: null,
      countryCode: null,
    };
  },
  computed: {
    ...mapState('loggedAccount', ['account']),
    ...mapState('common', ['whiteLabel']),
    showInfo() {
      if (this.account) return this.account && this.account.role === 'PATIENT';
      return !!this.whiteLabel;
    },
    showClinicName() {
      if (this.isGlobeMedActive && this.$t('external.clinicName') !== 'external.clinicName') return this.$t('external.clinicName');
      return this.$t('forms.clinicLabel');
    },
    showPhoneLabel() {
      if (this.isGlobeMedActive && this.$t('external.phoneLabel') !== 'external.phoneLabel') return this.$t('external.phoneLabel');
      return this.$t('forms.phoneLabel');
    },
    localeAdaptedClinicPhoneLabel() {
      return this.$vuetify.rtl ? `${this.showPhoneLabel} ${this.showClinicName}` : `${this.showClinicName} ${this.showPhoneLabel}`;
    },
    rtlAdaptedCountryCode() {
      return this.$adaptPhoneNumberArabic(this.countryCode, this.$vuetify.rtl);
    },
  },
  created() {
    if (this.whiteLabel) {
      this.setWhitelabelInfo();
    } else if (this.account) {
      this.setDefaultClinicInfo();
    }
  },
  methods: {
    setWhitelabelInfo() {
      this.clinicEmail = this.whiteLabel?.email || this.accountClinic?.contactEmail;
      this.setPhoneNumberAndCountryCode(this.whiteLabel.phone);
    },
    setDefaultClinicInfo() {
      const departmentPhone = this.account && this.account.department && this.account.department.phoneNumber;
      const phoneNumber = departmentPhone || this.accountClinic && this.accountClinic.phoneNumber;

      this.clinicEmail = this.accountClinic && this.accountClinic.contactEmail;
      this.setPhoneNumberAndCountryCode(phoneNumber);
    },
    setPhoneNumberAndCountryCode(phoneNumber) {
      this.clinicPhoneNumber = phoneNumber?.number;
      this.countryCode = phoneNumber?.countryCode;
    },
  },
};
</script>

<style lang="scss">

.c-phone-number {
  display: inline-flex;

   .c-country-code {
      margin-right: 2px;
   }
}

.c-email {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v-application--is-rtl {
  .c-phone-number {
   .c-country-code {
      order: 1;
    }
  }
}

</style>
